export default __webpack_public_path__ + "static/media/auditor_img.b8c37f8c.jpg";